import {CustomProp} from '../constants/Catalog';
import {adaptCatalogItem} from './CatalogUtils';
import {catalog} from '../constants';

/**
 * Gets the value from the given path through a data structure
 * @param {object} context
 * @param {...string|number} path
 * @return {*}
 *
 * @example
 * var context = { response: { data: { foo: 123 } } };
 * const value = getIn(context, 'response', 'data', 'foo');
 */
export const getValueIn = (context, ...path) => {
    let value = context;
    while (value !== undefined && value !== null && path.length) {
        value = value[path.shift()];
    }
    return value;
};

export const safeGetValueIn = (context, ...path) => {
    try {
        return getValueIn(context, ...path);
    } catch (e) {
        return null;
    }
};

/**
 * For a catalog offer, converts the array of customAttributes and keyImages into lookup objects, translates
 * featured status, determines bundle status, and determines the product slug the offer should link to
 *
 * @param {object} catalogOffer
 * @return {object}
 */
export const adaptCatalogOffer = catalogOffer => {
    const out = adaptCatalogItem(catalogOffer);

    if (catalogOffer.keyImages) {
        out.srcSet = catalogOffer.keyImages.reduce((acc, {type, url}) => {
            const formattedUrl = encodeURI(url);
            if (
                type === catalog.keyImageTypes.HORIZONTAL ||
                type === catalog.keyImageTypes.VERTICAL
            ) {
                acc[type] = formattedUrl;
            } else if (type === catalog.keyImageTypes.STORE_FRONT_TALL) {
                acc.vertical = formattedUrl;
            } else if (type === catalog.keyImageTypes.STORE_FRONT_WIDE) {
                acc.horizontal = formattedUrl;
            }
            return acc;
        }, {});
        out.src = catalogOffer.keyImages.reduce((acc, {type, url}) => {
            const formattedUrl = encodeURI(url);
            if (type === catalog.keyImageTypes.GAMEBOX_LOGO) {
                return formattedUrl;
            }
            return acc;
        }, undefined);
    }

    if (out.isFeatured) {
        out.isBanner = true;
    }

    if (catalogOffer.items) {
        const namespaceSet = catalogOffer.items.reduce((acc, {namespace}) => {
            acc.add(namespace);
            return acc;
        }, new Set());

        let productSlug;
        let webUrlOverride;
        for (let i = 0; i < catalogOffer.customAttributes.length; i++) {
            if (catalogOffer.customAttributes[i].key === CustomProp.PRODUCT_SLUG) {
                productSlug = catalogOffer.customAttributes[i].value;
            } else if (catalogOffer.customAttributes[i].key === CustomProp.WEB_URL_OVERRIDE) {
                webUrlOverride = catalogOffer.customAttributes[i].value;
            }
        }

        out.isBundle = namespaceSet.size > 1;
        // TODO TIf no explicit slug is set, we should look up the ns -> productName mapping in the product service
        out.detailNamespace = productSlug;
        out.webUrlOverride = webUrlOverride;
    }

    return out;
};

export const localeLanguageCode = locale => {
    const matches = locale.match(/^[^-_]*/, locale);
    return matches.length ? matches[0] : locale;
};
